import BackspaceIcon from '@mui/icons-material/Backspace';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import useDebounce from '../../../hooks/useDebounce';
import { requestContacts, setSearch } from '../../../store/conversationGrid';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';

const useStyles = makeStyles()({
    root: {
        height: '100%',
        padding: '2px 4px',
    },
    input: {
        width: 'calc(100% - 30px)',
    },
    icon: {
        fontSize: '1.3rem',
    },
});

export default function SearchContacts() {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();

    const searchKeyword = useAppSelector(state => state.conversationGrid.searchKeyword);

    const [inputValue, setInputValue] = React.useState<string>(searchKeyword);

    React.useEffect(() => {
        setInputValue(searchKeyword);
    }, [searchKeyword]);

    const debounceValue = useDebounce(inputValue, 500);

    React.useEffect(() => {
        if (debounceValue !== searchKeyword) {
            dispatch(setSearch({ searchKeyword: debounceValue }));
            dispatch(requestContacts());
        }
    }, [debounceValue]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(event.target.value);
    };

    const handleClear = () => {
        setInputValue('');
    };

    return (
        <Grid container direction="row" wrap="nowrap" alignItems="center" className={classes.root}>
            <Grid item xs={true}>
                <InputBase
                    placeholder="Search Contacts"
                    inputProps={{
                        'aria-label': 'Search contacts',
                    }}
                    value={inputValue}
                    onChange={handleChange}
                    className={classes.input}
                />
            </Grid>
            <Grid item xs="auto">
                <IconButton aria-label="Clear search" onClick={handleClear} size="small">
                    <BackspaceIcon className={classes.icon} />
                </IconButton>
            </Grid>
        </Grid>
    );
}
